import {APIError} from 'data/errors';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {
	GetCityLocationModel,
	GetCityLocationParams,
	GetCityLocation,
} from 'domain/usecases/private/booking-flow/health/get-city-location';

export class RemoteGetCityLocation implements GetCityLocation {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetCityLocationModel>,
	) {}

	async get({signal, ...params}: GetCityLocationParams): Promise<GetCityLocationModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
